import { CalendarId } from "@tento-lona/sheets";
import "./calendar-list-panel";

import { Storybook } from "@tento-ui/ui/storybook";
import { Toast } from "@tento-ui/components/toast/toast";
import { CalendarListPanel } from "./calendar-list-panel";
import { Network } from "@tento-lona/network";

// Bound-size frame so the panel (width/height:100%) renders inside the story card.
function $frame($el: HTMLElement): HTMLElement {
  const $slot = document.createElement("div");
  $slot.style.display = "flex";
  $slot.style.justifyContent = "center";
  $slot.style.width = "420px";
  $slot.style.height = "560px";
  $slot.appendChild($el);
  return $slot;
}

const SAMPLE: Network.CalendarList[] = [
  {
    authId: Network.AuthId.of("auth_demo"),
    isPrimary: true,
    calendars: [
      { id: CalendarId.of("primary"), summary: "Personal", colorId: "1", accessRole: "owner", capabilities: null, source: "google", eventsLookupKey: ":~google:auth_demo:calendar:primary:events" },
      { id: CalendarId.of("work"), summary: "Work", colorId: "5", accessRole: "owner", capabilities: null, source: "google", eventsLookupKey: ":~google:auth_demo:calendar:work:events" },
      { id: CalendarId.of("side-project"), summary: "Side Project", colorId: "9", accessRole: "owner", capabilities: null, source: "google", eventsLookupKey: ":~google:auth_demo:calendar:side-project:events" },
      { id: CalendarId.of("team@lona.so"), summary: "Team", colorId: "11", accessRole: "reader", capabilities: null, source: "google", eventsLookupKey: ":~google:auth_demo:calendar:team@lona.so:events" },
    ],
  },
];

export class CalendarListPanelStoryBook extends Storybook.Default {
  title(): string {
    return "Calendar List Panel";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Populated",
        render: () =>
          $frame(
            CalendarListPanel.makeWith({
              kind: "list",
              calendars: SAMPLE,
              options: { padding: "12px 20px" },
            }),
          ),
      },
      {
        title: "Null state — no calendars",
        render: () =>
          $frame(CalendarListPanel.makeWith({ kind: "no-calendars" })),
      },
      {
        title: "Null state — no Google account",
        render: () =>
          $frame(
            CalendarListPanel.makeWith({
              kind: "no-account",
              onConnectGoogle: () => Toast.info("Connect Google"),
            }),
          ),
      },
      {
        title: "Expired auth",
        render: () =>
          $frame(
            CalendarListPanel.makeWith({
              kind: "expired-auth",
              source: "google",
              authId: Network.AuthId.of("auth_demo"),
            }),
          ),
      },
    ];
  }
}
